import { Outlet } from 'react-router-dom'

import { CampaignListPage } from '@features/promotionCampaign/pages/CampaignListPage'
import { CreateCampaignPage } from '@features/promotionCampaign/pages/CreateCampaignPage'
import { EditCampaignPage } from '@features/promotionCampaign/pages/EditCampaignPage'
import { CampaignDetailPage } from '@features/promotionCampaign/pages/CampaignDetailPage'

export const promotionCampaignRoutes = [
  {
    path: 'promotion-campaign',
    element: <Outlet />,
    children: [
      {
        path: '',
        element: <CampaignListPage />,
      },
      {
        path: 'create/:type',
        element: <CreateCampaignPage />,
      },
      {
        path: 'edit/:id',
        element: <EditCampaignPage />,
      },
      {
        path: ':id',
        element: <CampaignDetailPage />,
      },
    ],
  },
]
